export const getBasicComprehensionValidationMessageConstants = title => ({
    WEB_ENTRY_HEADER_ERROR_TEXT: 'Please fix errors in the highlighted cells.',
    WRONG_TYPE_ERROR: {
        code: 'BASIC_COMPREHENSION_WRONG_TYPE',
        text: 'Correct and incorrect scores should be positive integers.',
    },
    BM_EMPTY_FIELD_ERROR: {
        code: 'BASIC_COMPREHENSION_BM_EMPTY_FIELD_ERROR',
        text: `Each student's ${title} entry must include the assessment date and the correct and incorrect scores.`,
    },
    PM_EMPTY_FIELD_ERROR: {
        code: 'BASIC_COMPREHENSION_PM_EMPTY_FIELD_ERROR',
        text: `Each student's ${title} entry must include the assessment date, form number and the correct and incorrect scores.`,
    },
    WRONG_SUM_OF_VALUES_ERROR: {
        code: 'BASIC_COMPREHENSION_WRONG_SUM_OF_VALUES',
        text: `The student's combined correct and incorrect scores exceed the number of items in the completed ${title} probe.`,
    },
});

export default { getBasicComprehensionValidationMessageConstants };
